/**
 * Skala napisów, których nie da się wyrazić samym komponentem — te klasy
 * doklejają się do komórek siatki, nagłówków kart i pasków sekcji, gdzie
 * element nośny jest już czymś innym (`<div role="columnheader">`, `<button>`).
 *
 * Komponenty na tych samych klasach stoją w `Title.tsx`; bierz je wszędzie,
 * gdzie napis ma własny element.
 */

/** Tytuł ekranu rekordu — 22 px / 800, `letter-spacing:-.01em`, `#12141A`. */
export const screenTitleClass =
  'text-[22px] font-extrabold tracking-[-.01em] text-ink';

/** Etykieta wersalikowa nagłówka sekcji — 12 px / 700, `.12em`, `#5A5F6B`. */
export const sectionLabelClass =
  'text-xs font-bold uppercase tracking-[.12em] text-neutral-700';

/**
 * Etykieta wersalikowa nagłówka kolumny — 12 px / 700, `.08em`, `#9A9EAA`.
 * Poza nagłówkami kolumn niosą ją także tytuły kart i paneli: w projekcie
 * stoją w tym samym, wyciszonym kolorze.
 */
export const columnLabelClass =
  'text-xs font-bold uppercase tracking-[.08em] text-neutral-400';
